import React, { Component } from 'react'
import { Infotip } from '../../../../../../../../styleguide'
import { Button, Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHashtag, faPhone } from '@fortawesome/free-solid-svg-icons'

class Phone extends Component {
  state = {
    shown: false,
    phoneValue: ''
  }

  promiseInfo = {}

  show = async (initialValue = '') => {
    return new Promise((resolve, reject) => {
      this.promiseInfo = { resolve, reject };
      this.setState({ shown: true, phoneValue: initialValue });
    });
  }

  save = async () => {
    const { phoneValue } = this.state;
    this.setState({ shown: false });
    return this.promiseInfo.resolve(phoneValue);
  }
  
  cancel = () => {
    try {
      this.promiseInfo.reject();
    } catch (_) {}
    this.setState({ shown: false, phoneValue: '' });
  }

  hide = () => {
    try {
    } catch (_) {
      this.promiseInfo.reject()
    }
    this.setState({ shown: false })
  }

  render() {
    const menu = (
      <div>
        <div>
          <Input
            value={this.state.phoneValue}
            onInput={({ target: { value } }) => (typeof +value === 'number' && !isNaN(+value)) && this.setState({ phoneValue: value })}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: 5 }}>
          <Button
            style={{ width: '45%' }}
            type='primary'
            onClick={() => this.save()}
            disabled={!this.state.phoneValue}
          >
            SAVE
          </Button>
          <Button
            style={{ width: '45%' }}
            variant='outlined'
            onClick={() => this.cancel()}
          >
            CANCEL
          </Button>
        </div>
      </div>
    )

    return (
      <button id="ql-phone" className="ql-phone" style={{ width: 21 }} >
        <Infotip
          open={this.state.shown}
          placement="bottomLeft"
          className="id-infotip"
          content={menu}
          trigger="click"
        >
          <span>
            <FontAwesomeIcon icon={faPhone} />
          </span>
        </Infotip>
      </button>
    )
  }
}

export default Phone